<template>
  <div>
    <Subheader title="Legal notice" />

    <div class="app-content-column">
      <div id="terms-and-conditions" class="card">
        <h5>Terms and Conditions</h5>
        <p><em>Last updated: October 18, 2020</em></p>
        <p>
          Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before
          using the MzingoPartners.com website (the "Service") operated by Mzingo Development Ltd
          ("Mzingo Partners", "us", "we", or "our"). Your access to and use of the Service is
          conditioned upon your acceptance of and compliance with these Terms. These Terms apply to
          all visitors, users and others who wish to access or use the Service.
        </p>
        <p>
          <b>ARBITRATION AND CLASS ACTION WAIVER:</b> EXCEPT AS OTHERWISE DESCRIBED BELOW, BY USING
          THE SERVICE, YOU AGREE THAT ANY DISPUTE YOU HAVE WITH MZINGO PARTNERS WILL BE RESOLVED BY
          BINDING, INDIVIDUAL ARBITRATION, AND YOU WAIVE YOUR RIGHT TO PARTICIPATE IN A CLASS ACTION
          SUIT.
        </p>
        <p>
          By accessing or using the Service you agree to be bound by these Terms. If you disagree
          with any part of the terms, then you do not have permission to access the Service.
        </p>

        <h5>Communications</h5>
        <p>
          By creating an Account on our Service, you agree to subscribe to newsletters, marketing or
          promotional materials and other information we may send. However, you may opt out of
          receiving any, or all, of these communications from us by following the unsubscribe link
          or instructions provided in any email we send.
        </p>
        <p>
          By accessing the Service, you consent to the processing/use of identifying information,
          such as contact information, including a telephone number. You agree to receive
          notifications on your phone, including text messages (you may be charged for your text
          message according to your mobile operator tariff plans). You have the right to refuse to
          receive SMS notifications by sending a letter of appropriate content to e-mail
          <a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a>.
        </p>

        <h5>Prohibited Activities</h5>
        <p>
          You are solely responsible for your conduct and your content when using the Service and
          for compliance with these terms. You agree that you will not post, email or make available
          any content or use the Service:
        </p>
        <ul>
          <li>
            In a manner that is fraudulent, deceptive, or dishonest with respect to any charitable
            project or the collection or use of funds for such projects;
          </li>
          <li>
            In a manner that infringes, violates or misappropriates any third party's intellectual
            property rights or other proprietary rights or contractual rights;
          </li>
          <li>
            In a manner that transmits and/or installs trojan horses, malware, viruses or any other
            computer code, files or programs designed to interrupt, destroy or limit the
            functionality of any computer software or hardware or telecommunications equipment;
          </li>
          <li>
            To engage in spamming, "chain letters," "pyramid schemes", advertisement of illegal or
            controlled products or services, or other advertising or marketing activities that
            violate these Terms of Service, any applicable laws, regulations or generally accepted
            advertising industry guidelines;
          </li>
          <li>
            In a manner that is misleading, deceptive or fraudulent or otherwise illegal or promotes
            illegal activities, including engaging in phishing or otherwise obtaining financial or
            other personal information in a misleading manner or for fraudulent or misleading
            purposes;
          </li>
          <li>
            In a manner that is libelous or defamatory, or in a way that is otherwise threatening,
            abusive, violent, harassing, malicious or harmful to any person or entity, or invasive
            of another's privacy;
          </li>
          <li>In a manner that is harmful to minors in any way;</li>
          <li>
            In a manner that is hateful or discriminatory based on race, color, sex, religion,
            nationality, ethnic or national origin, marital status, disability, sexual orientation
            or age or is otherwise objectionable in Mzingo Partners’ sole discretion;
          </li>
          <li>
            To impersonate any other person, or falsely state or otherwise misrepresent your
            affiliation with any person or entity, or to obtain access to the Service without
            authorization;
          </li>
          <li>
            To interfere or attempt to interfere with the proper working of the Service or prevent
            others from using the Service, or in a manner that disrupts the normal flow of dialogue
            with an excessive number of messages (flooding attack) to the Service, or that otherwise
            negatively affects other persons' ability to use the Service;
          </li>
          <li>
            To use any manual or automated means, including agents, robots, scripts, or spiders, to
            access or manage any user's account or to monitor or copy the Service or the content
            contained therein;
          </li>
          <li>To facilitate the unlawful distribution of copyrighted content;</li>
          <li>
            In a manner that includes personal or identifying information about another person
            without that person's explicit consent;
          </li>
          <li>
            In a manner that employs misleading email or IP addresses, or forged headers or
            otherwise manipulated identifiers in order to disguise the origin of content transmitted
            through the Service or to users; and
          </li>
          <li>
            In a manner that constitutes or contains any form of advertising or solicitation if
            emailed to users who have requested not to be contacted about other services, products
            or commercial interests.
          </li>
        </ul>
        <p>Additionally, you agree not to:</p>
        <ul>
          <li>"Stalk" or otherwise harass anyone;</li>
          <li>
            Collect, use or disclose data, including personal information, about other users without
            their consent or for unlawful purposes or in violation of applicable law or regulations
            in Kenya or your country of domicile;
          </li>
          <li>
            Request, solicit or otherwise obtain access to usernames, passwords or other
            authentication credentials from any user of the Service or to proxy authentication
            credentials for any user of the Service for the purposes of automating logins to the
            Service;
          </li>
          <li>Post any unlawful content;</li>
          <li>
            Post any content of a sexual nature, including without limitation pornography, adult
            content, and/or content containing nudity;
          </li>
          <li>
            Use automated means, including spiders, robots, crawlers, data mining tools, or the like
            to download data from the Service - except for Internet search engines (e.g. Google) and
            non-commercial public archives (e.g. archive.org) that comply with our robots.txt file,
            or "well-behaved" web services/RSS/Atom clients. We reserve the right to define what we
            mean by "well-behaved";
          </li>
          <li>
            Post irrelevant content, repeatedly post the same or similar content or otherwise impose
            an unreasonable or disproportionate load on the Service's infrastructure;
          </li>
          <li>
            Attempt to gain unauthorized access to our computer systems or engage in any activity
            that disrupts, diminishes the quality of, interferes with the performance of, or impairs
            the functionality of, the Service;
          </li>
          <li>Use the Service as a generic file hosting service;</li>
          <li>
            Take any action that may undermine feedback or ratings systems (such as displaying,
            importing or exporting feedback information from the Service or for using it for
            purposes unrelated to this Service);
          </li>
          <li>
            Develop, invoke, or utilize any code to disrupt, diminish the quality of, interfere with
            the performance of, or impair the functionality of the Service;
          </li>
          <li>
            Make copies of all or part of the Service, except as required for the intended use of
            the Service.
          </li>
          <li>
            Use all or part of the Service to earn income or otherwise receive benefits in a
            third-party service capacity, or market any part of the Service in an information
            providing capacity.
          </li>
          <li>Modify, translate, or create a derivative work of part or all of the Service.</li>
          <li>
            Directly or indirectly attempt to recompile, manipulate, or reverse engineer the
            Service, in whole or in part.
          </li>
          <li>
            Remove, alter, or tamper with copyright, trademark, patent or other intellectual
            property markings for the Service.
          </li>
          <li>
            Retain, store, compile or aggregate data received from the Service to (1) create a
            database or electronic collection of such data or (2) republish or retransmit data
            received from the Service other than with clear attribution of content to the Service
            that includes a web link to the Service.
          </li>
        </ul>
        <p>
          You agree not to authorize or encourage any third party to use the Service to facilitate
          any of the foregoing prohibited conduct. You also agree that these Terms of Service inure
          to the benefit of our service providers (including our network platform provider) and that
          they may take action (including the removal of your content and disabling of your account)
          in order to maintain compliance with these Terms of Service. Notwithstanding anything to
          the contrary, by using the Service you agree to indemnify and hold harmless ourselves &
          our service providers on all matters related to your interaction with others using the
          Service.
        </p>

        <h5>Terms relating to Posting Projects and other Content</h5>
        <p>
          Our Service may permit you to post, link, store, share and otherwise make available
          certain information, text, graphics, videos, or other material (generally "Content"). You
          are responsible for the Content that you post on or through the Service, including its
          legality, reliability, and appropriateness.
        </p>
        <p>
          By posting Content on or through the Service, You represent and warrant that: (i) the
          Content is yours (you own it) and/or you have the right to use it and the right to grant
          us the rights and license as provided in these Terms, (ii) that the posting of your
          Content on or through the Service does not violate the privacy rights, publicity rights,
          copyrights, contract rights or any other rights of any person or entity and (iii)
          projects, needs and ideas – and the associated financial estimates – are original,
          accurate, and verifiable. We reserve the right to terminate the account of anyone found to
          be infringing on a copyright.
        </p>
        <p>
          You retain any and all of your rights to any Content you submit, post or display on or
          through the Service and you are responsible for protecting those rights. We take no
          responsibility and assume no liability for Content you or any third-party posts on or
          through the Service. However, by posting Content using the Service you grant us the right
          and license to use, modify, publicly perform, publicly display, reproduce, and distribute
          such Content on and through the Service. You agree that this license includes the right
          for us to make your Content available to other users of the Service or affiliated third
          parties, who may also use your Content subject to these Terms. Mzingo Partners has the
          right but not the obligation to monitor and edit or remove any Content provided by users.
        </p>
        <p>
          When you post information about a project seeking donations, you represent and warrant
          that:
        </p>
        <ol class="roman">
          <li>All information you provide is accurate and complete;</li>
          <li>Donations received will be used exactly as described in the materials you post;</li>
          <li>
            You will comply with any applicable financial reporting obligations, including without
            limitation tax reporting and asset disclosures for your project;
          </li>
          <li>
            We are authorized to provide information about you, your account, and your project to
            donors, beneficiaries, financial institutions, regulatory authorities, and government
            agencies as we deem appropriate in our sole discretion; If the transfer of such
            information takes place outside Kenya, Mzingo Partners ensures that the jurisdiction of
            the destination has as nearly a similar data protection laws and that the transfer of
            such data is necessary for the implementation of projects.
          </li>
          <li>
            You will cooperate fully in any inspection, audit or other investigation by Mzingo
            Partners or any other entity or agency, whenever such cooperation is requested by Mzingo
            Partners.
          </li>
        </ol>
        <p>You have the right to:</p>
        <ol class="roman">
          <li>to be informed of the use to which your personal data is to be p</li>
          <li>to access your personal data in custody of data processor;</li>
          <li>to object to the processing of all or part of your personal data;</li>
          <li>to correction of false or misleading data;</li>
          <li>to deletion of false or misleading data about you;</li>
          <li>provision & access to said data/information shall be at your cost.</li>
        </ol>
        <p>
          Submitting an idea for funding in no ways guarantees that the effort will be funded. If
          funding is received, the recipient must demonstrate the full and accurate use of the
          received funds. Mzingo Partners, in its sole discretion, reserves the right to suspend,
          cease, or reverse the collection and/or distribution of donations for any project that it
          suspects of violating these Terms of Service. Any violation of the requirements herein may
          result in immediate termination from the platform, recovery of any funds received>,
          reports to appropriate authorities, and appropriate legal action.
        </p>
        <p>
          Content delivered through the Service is the property of Mzingo Partners and its platform
          provider, Aegas LLC, or is provided with permission. You may not distribute, modify,
          transmit, reuse, download, repost, copy, or use said Content, whether in whole or in part,
          for commercial purposes or for personal gain, without express advance written permission
          from us.
        </p>

        <h5>Donations</h5>
        <p>
          Mzingo Partners is a non-profit limited liability company registered in the Republic of
          Kenya. Donations to Mzingo Partners and through its platform are NOT tax-deductible to the
          full extent of the law, less deemed tax-deductible in your country of residence so we
          advise you to confirm any contributions with your accountant/local tax laws.
        </p>
        <p>
          The service uses PayPal to make money transfers. You acknowledge that Mzingo Partners is
          not responsible for your use of the PayPal service, and that you bear all costs and risks
          associated with making payments through the PayPal service at your own risk. In addition,
          when making payments through PayPal you agree to the connection between PayPal and the
          Mzingo Partners will exchange your Personal Data and other information directly in the
          order to make a payment. Information will also be used with PayPal’s privacy practices.
        </p>
        <p>
          The Service is an informational platform that provides information regarding projects and
          permits you to evaluate projects listed on the service and make donations if you choose to
          do so.
        </p>
        <p>
          All donations are at your own risk. When you make a donation through the Service, it is
          your responsibility to understand how your money will be used. Mzingo Partners does its
          best to validate each project description before it is posted but does not guarantee that
          the information and content provided is accurate, complete, or up to date, and has no
          control over the conduct of individuals associated with a project or whether any donation
          will be used in the manner you intend or expect.
        </p>
        <p>
          Notwithstanding the foregoing, Mzingo Partners takes seriously any suggestion that donated
          funds are being misused. If you believe that a project is misusing funds, please notify
          Mzingo Partners so that we can investigate & initiate appropriate remedial action.
        </p>
        <p>
          None of the content in the Service constitutes tax, financial, or legal advice. Before
          making a donation, you should consult tax, financial, legal, or other advisors as
          appropriate. You are responsible for obtaining information and making a final decision
          about the value of contributing to any project.
        </p>

        <h5>Accounts</h5>
        <p>
          When you create an account with us, you guarantee that you are above the age of 18, and
          that the information you provide us is accurate, complete, and current at all times.
          Inaccurate, incomplete, or obsolete information may result in the immediate termination of
          your account on the Service.
        </p>
        <p>
          You are responsible for maintaining the confidentiality of your account and password,
          including but not limited to the restriction of access to your computer and/or account.
          You agree to accept responsibility for any and all activities or actions that occur under
          your account and/or password, whether your password is with our Service or a third-party
          service. You must notify us immediately upon becoming aware of any breach of security or
          unauthorized use of your account.
        </p>
        <p>
          You may not use as a username the name of another person or entity or that is not lawfully
          available for use, a name or trademark that is subject to any rights of another person or
          entity other than you, without appropriate authorization. You may not use as a username
          any name that is offensive, vulgar or obscene.
        </p>

        <h5>Intellectual Property</h5>
        <p>
          The Service and its original content (excluding Content provided by users), features and
          functionality (current or described as intended in the future) are and will remain the
          exclusive property of Mzingo Partners, Aegas LLC, and their licensors. The Service is
          protected by copyright, trademark, and other laws of both the Republic of Kenya and
          foreign countries. Our trademarks and trade dress may not be used in connection with any
          product or service without the prior written consent of Mzingo Partners.
        </p>

        <h5>Links to Other Web Sites</h5>
        <p>
          Our Service may contain links to third party web sites or services that are not owned or
          controlled by Mzingo Partners. Mzingo Partners has no control over, and assumes no
          responsibility for the content, privacy policies, or practices of any third-party web
          sites or services. We do not warrant the offerings of any of these entities/individuals or
          their websites.
        </p>
        <p>
          You acknowledge and agree that Mzingo Partners shall not be responsible or liable,
          directly or indirectly, for any damage or loss caused or alleged to be caused by or in
          connection with use of or reliance on any such content, goods or services available on or
          through any such third party web sites or services. We strongly advise you to read the
          terms and conditions and privacy policies of any third-party web sites or services that
          you visit.
        </p>

        <h5>Termination</h5>
        <p>
          We may terminate or suspend your account and bar access to the Service immediately,
          without prior notice or liability, under our sole discretion, for any reason whatsoever
          and without limitation, including but not limited to a breach of the Terms. If you wish to
          terminate your account, you may simply discontinue using the Service/ unsubscribe from the
          service. All provisions of the Terms which by their nature should survive termination
          shall survive termination, including, without limitation, ownership provisions, warranty
          disclaimers, indemnity and limitations of liability.
        </p>

        <h5>Disclaimers</h5>
        <p>
          Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and
          "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether
          express or implied, including, but not limited to, implied warranties of merchantability,
          fitness for a particular purpose, non-infringement, or course of performance.
        </p>
        <p>
          Mzingo Partners, Aegas LLC, their subsidiaries, affiliates, and their licensors do not
          warrant that a) the Service will function without interruption, or be secure or available
          at any particular time or location; b) that any errors or defects will be identified or
          corrected; c) the Service is free of viruses or other harmful components; or d) the
          results of using the Service will meet your requirements.
        </p>

        <h5>Release and Indemnification</h5>
        <p>
          You release Mzingo Partners, Aegas LLC, and their officers, directors, employees and
          agents from claims, demands and damages (actual and consequential) of every type, known
          and unknown, connected in any way with (i) donations you make using the Service or in
          response to information you receive from the Service, (i.a) donations you receive by using
          the Service or in response to information you presented using the Service, and/or (ii) any
          dispute you have with another user of the Service arising from use of the Service. You
          expressly waive any statutory or other protection that would otherwise limit this release
          to claims that you know of (or suspect to exist) when you open your account and agree to
          this release.
        </p>
        <p>
          You agree to defend, indemnify and hold harmless Mzingo Partners, its licensees and
          licensors, and their employees, contractors, agents, officers and directors, from and
          against any and all claims, damages, obligations, losses, liabilities, costs or debt, and
          expenses (including but not limited to attorney's fees), resulting from or arising out of
          a) use of and access to the Service, by you or any person using your account and password;
          b) a breach of these Terms, c) your violation of any law or other rights of a third party,
          d) your failure to honor the terms of any donation using the Service, or d) your Content
          posted on the Service.
        </p>

        <h5>Limitation of Liability</h5>
        <p>
          In no event shall Mzingo Partners nor its directors, employees, partners, agents,
          suppliers, or affiliates, be liable for any indirect, incidental, special, consequential
          or punitive damages, including without limitation, loss of profits, data, use, goodwill,
          or other intangible losses, resulting from (i) your access to or use of or inability to
          access or use the Service; (ii) any conduct or content of any third party on the Service;
          (iii) any content obtained from the Service; and (iv) unauthorized access, use or
          alteration of your transmissions or content, whether based on warranty, contract, tort
          (including negligence) or any other legal theory, whether or not we have been informed of
          the possibility of such damage, and even if a remedy set forth herein is found to have
          failed of its essential purpose.
        </p>

        <h5>Exclusions</h5>
        <p>
          Some jurisdictions do not allow the exclusion of certain warranties or the exclusion or
          limitation of liability for consequential or incidental damages, so the limitations above
          may not apply to you.
        </p>

        <h5>Governing Law</h5>
        <p>
          These Terms shall be governed and construed in accordance with the laws of the Republic of
          Kenya, without regard to any conflict of law provisions. Our failure to enforce any right
          or provision of these Terms will not be considered a waiver of those rights. If any
          provision of these Terms is held to be invalid or unenforceable by a court, the remaining
          provisions of these Terms will remain in effect. These Terms constitute the entire
          agreement between us regarding our Service and supersede and replace any prior agreements
          we might have had between us regarding the Service.
        </p>

        <h5>Disputes</h5>
        <p>
          Arbitration; Class Action Waiver. ALL DISPUTES BETWEEN YOU AND US OR ANY OF OUR OFFICERS,
          DIRECTORS OR EMPLOYEES (WHETHER OR NOT SUCH DISPUTE INVOLVES A THIRD PARTY) WITH REGARD TO
          YOUR RELATIONSHIP WITH US, INCLUDING WITHOUT LIMITATION DISPUTES RELATED TO THESE TERMS OF
          SERVICE, YOUR USE OF THE SERVICE, AND/OR RIGHTS OF PRIVACY AND/OR PUBLICITY, WILL BE
          RESOLVED BY BINDING, INDIVIDUAL ARBITRATION. DISCOVERY AND RIGHTS TO APPEAL ARE GENERALLY
          MORE LIMITED IN ARBITRATION THAN IN A LAWSUIT, AND OTHER RIGHTS THAT YOU WOULD HAVE IN
          COURT MAY NOT BE AVAILABLE IN ARBITRATION. BY ENTERING INTO THESE TERMS, YOU ARE ALSO
          WAIVING YOUR RIGHT TO PARTICIPATE IN A CLASS ACTION SUIT.
        </p>
        <p>
          Notwithstanding the foregoing, nothing in these Terms of Service will be deemed to waive,
          preclude, or otherwise limit the right of either of us to (a) bring an individual action
          in small claims court; (b) submit a complaint or otherwise pursue action through a
          federal, state, or local agency; (c) seek an injunction in a court of law; or (d) file an
          intellectual property infringement claim in a court of law.
        </p>
        <p>
          <em>
            Any arbitration under this Agreement will be settled under the
          </em>
          <b>
            ARBITRATION ACT.
          </b>
          <em>
            CHAPTER 49 Laws of Kenya by
          </em>
          <b>
            Chartered Institute of Arbitrators
          </b>
          <em>under its Arbitration Rules</em>.
        </p>
        <p>
          A party who intends to seek arbitration must first send a written notice of the dispute to
          the other party by certified mail (signature required) or, only if that other party has
          not provided a current physical address, then by electronic mail (“Notice of
          Arbitration”). Our current address for Notice is: Mzingo Partners AMICUS PLAZA, ALONG
          KISII MIGORI ROAD, P. O. Box 417 - 40400 The Notice of Arbitration must: (a) describe the
          claim or dispute and its basis; and (b) set forth the specific relief desired (“Demand”).
          We will make a good faith effort to resolve the claim directly, but if there is no
          resolution within 60 days after the Notice of Arbitration is received, either party may
          commence an arbitration proceeding. Arbitration proceedings between the parties will be
          confidential unless otherwise agreed by the parties in writing.
        </p>
        <p>
          Any arbitration hearing will take place at an agreed upon location in the Republic of
          Kenya, but if the claim is for $1,000 or less, you may choose whether the arbitration will
          be conducted: (a) solely on the basis of documents submitted to the arbitrator; (b)
          through a telephone hearing or (c) by an in-person hearing as established by the
          <b>Chartered Institute of Arbitrators</b> Rules in the country of your billing address. If
          the arbitration finds that either the substance of your claim or the relief sought in the
          Demand is frivolous or brought for an improper purpose (as measured by the standards set
          forth in the Federal Rule of Civil procedure 11(b)), then the payment of all fees will be
          governed by the <b>Chartered Institute of Arbitrators</b> Rules. In that case, you agree
          to reimburse us for all monies previously disbursed by us that are otherwise your
          obligation to pay under the <b>Chartered Institute of Arbitrators</b> Rules. Regardless of
          the manner in which the arbitration is conducted, the arbitrator must issue a reasoned
          written decision sufficient to explain the essential findings and conclusions on which the
          decision and award, if any, are based. The arbitrator may make rulings and resolve
          disputes as to the payment and reimbursement of fees or expenses at any time during the
          proceedings and upon request from either party made within 14 days of the arbitrator’s
          ruling on the merits.
        </p>
        <p>
          No Class Actions. YOU MAY BRING CLAIMS AGAINST US ONLY IN YOUR INDIVIDUAL CAPACITY AND NOT
          AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
          Further, unless both you and we agree otherwise, an arbitrator may not consolidate more
          than one person’s claims and may not otherwise preside over any form of a representative
          or class proceeding.
        </p>
        <p>
          Modifications to this Arbitration Provision. If we make any future change to this
          arbitration provision, other than a change to our address for Notice of Arbitration, you
          may reject the change by sending us written notice within 30 days of the change to our
          address for Notice of Arbitration, in which case your account with us will be immediately
          terminated and this arbitration provision, as in effect immediately prior to the changes
          you rejected will survive.
        </p>
        <p>
          Enforceability. If this Disputes section is found to be unenforceable, then the entirety
          of this Disputes section will be null and void and, in that case, the courts located in
          Kenya shall have exclusive jurisdiction over any action arising out of or related to these
          Terms of Service.
        </p>
        <p>
          Confidentiality. We each agree to keep the arbitration proceedings, all information
          exchanged between us, and any settlement offers confidential, unless otherwise required by
          law or requested by law enforcement or any court or governmental body. However, we may
          each disclose these matters, in confidence, to our respective accountants, auditors, and
          insurance providers.
        </p>

        <h5>Changes</h5>
        <p>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time
          by posting revised terms at this location. By continuing to access or use our Service
          after any revisions become effective, you agree to be bound by the revised terms. If you
          do not agree to the new terms, you are no longer authorized to use the Service or your
          account on the Service.
        </p>

        <h5>Contact Us</h5>
        <p>
          If you have any questions about these Terms, please contact us at
          <a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a>.
        </p>

        <h5>Infringement Claims - Digital Millennium Copyright Act</h5>
        <p>
          Pursuant to the Digital Millennium Copyright Act (Title 17 USC 512(c)), a copyright owner
          or their agent may submit a takedown notice relating to material posted to the Service.
          Mzingo Partners is entitled to claim immunity from infringement claims pursuant to the
          “safe harbor” provisions of the DMCA.
        </p>
        <p>
          Users who violate the Service’s internal repeat infringer policy will have their accounts
          terminated.
        </p>

        <h5>Infringement Claims</h5>
        <p>
          To submit an infringement claim to Mzingo Partners, you must provide a notice including
          the following information:
        </p>
        <ul>
          <li>Identification of the copyrighted work claimed to have been infringed.</li>
          <li>
            Identification of the infringing material to be removed, and information reasonably
            sufficient to permit Mzingo Partners to locate the material.
          </li>
          <li>
            Contact information including your name, physical address, email address, and phone
            number.
          </li>
          <li>
            A statement that the complaining party has a good faith belief that the use of the
            material is unauthorized.
          </li>
          <li>
            A statement that the information in the notification is accurate, and, under penalty of
            perjury, that the complaining party is authorized to act on behalf of the copyright
            owner.
          </li>
          <li>
            A physical or electronic signature of the copyright owner (or authorized
            representative).
          </li>
        </ul>

        <p>
          Civil damage penalties, including costs and attorney fees, may apply against any person
          who knowingly and materially misrepresents certain information in a notification of
          infringement. Send all takedown notices to
          <a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a>. Please note that
          the identity and information in any copyright infringement claim we receive may be
          communicated to the alleged infringer.
        </p>

        <h5>Disputing a Take Dow</h5>
        <p>
          If you have received a notice that your Content was taken down because of a copyright
          infringement claim, you may provide us with a counter notification in an effort to have
          the material in question restored to the Service(s). The notification must be sent in
          writing to <a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a> and must
          contain the following elements (17 USC 512(g)(3)):
        </p>
        <ul>
          <li>
            A description of the material that has been taken down and the original location of the
            material before it was taken down.
          </li>
          <li>
            A statement under penalty of perjury that you have a good faith belief that the material
            was removed or disabled because of mistake or misidentification of the material.
          </li>
          <li>
            Your name, address, and telephone number, and a statement that you consent to the
            jurisdiction of the federal district court for the judicial district in which the
            address is located (or if you are outside of the Republic of Kenya, that you consent to
            jurisdiction of any judicial district in which the service provider may be found), and
            that the you will accept service of process from the person or company who provided the
            original infringement notification.
          </li>
          <li>Your physical or electronic signature.</li>
        </ul>
        <p>
          If we receive a counter-notice, we will send a copy of the counter-notice to the original
          complaining party, informing that person that we may replace the removed content or cease
          disabling it in 10 business days. Unless the copyright owner files an action seeking a
          court order against the content provider or user, the removed content may be replaced, or
          access to it restored, in 10 to 14 business days or more after receipt of the
          counter-notice, in our sole discretion.
        </p>

        <h5>General</h5>
        <p>
          These Terms of Service constitute the entire agreement between you and Mzingo Partners and
          govern your use of the Service, superseding any prior agreements between you and us with
          respect to the Service. The failure of Mzingo Partners to exercise or enforce any right or
          provision of these Terms of Service will not constitute a waiver of such right or
          provision. If any provision of these Terms of Service is found by a court of competent
          jurisdiction to be (or are otherwise) invalid, the parties nevertheless consent that the
          court should endeavor to give effect to the parties’ intentions as reflected in the
          provision, and the other provisions of these Terms of Service remain in full force and
          effect. You agree that regardless of any statute or law to the contrary, any claim or
          cause of action arising out of or related to use of the Services or these Terms of Service
          must be filed within one (1) year after such claim or cause of action arose or be forever
          barred. Notices to you may be made via either email or regular mail. The Service may also
          provide notices to you of changes to these Terms of Service or other matters by displaying
          notices or links to notices generally on the website or via application.
        </p>
      </div>

      <div id="privacy-policy" class="card policy">
        <h5>Privacy policy</h5>
        <p><em>Effective date: 30.11.2020</em></p>
        <p>
          The <a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a> web site
          (“Service”) is provided by Mzingo Development Ltd, a Kenya-based locally owned small
          business, based in 417-40400, Amicus Plaza, Suna-Migori, Kenya.
        </p>
        <p>
          Mzingo Partners provides this Privacy Policy to inform you of Mzingo Partners policies and
          procedures regarding the processing of personal data Mzingo Partners receives about
          individuals who attend or use
          <a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a> (the “Service”).
        </p>
        <p>
          Sections titles below are for informational reasons only and do not alter the meaning of
          the individual terms therein.
        </p>

        <h5>The Personally Identifiable Information Collected</h5>
        <ol>
          <li>
            In the course of using the Service, you may provide Mzingo Partners with personally
            identifiable information. This refers to information about you that can be used to
            contact or identify you, and information on your use of and activities at the Service
            that may be connected with you (“Personal Data”). Personal Data that Mzingo Partners
            collects may include, but is not limited to, your name, phone number, email address or
            other contact data provided by you via the Service and technical data collected
            automatically by using cookies.
          </li>
          <li>
            When you visit the Site, Mzingo Partners servers automatically record information that
            your browser sends whenever you visit a website. This information may include, but is
            not limited to, your computer’s Internet Protocol address, browser type, the web page
            you were visiting before you came to the Service and information you search for on the
            Service.
          </li>
          <li>
            Like many websites, Mzingo Partners may also use “cookies” to collect information. A
            cookie is a small data file that Mzingo Partners transfers to your computer’s hard disk
            for record-keeping purposes. Mzingo Partners may use “persistent cookies” in terms of
            usage of analytical tools (Google Analytics, Inspectlet); and Mzingo Partners uses
            “session ID cookies” to enable certain features of the Site, to better understand how
            you interact with the Site and to monitor aggregate usage and web traffic routing on the
            Service. You can instruct your browser, by changing its options, to stop accepting
            cookies or to prompt you before accepting a cookie from the websites you visit. If you
            do not accept cookies, however, you may not be able to use all portions of the Service
            or all functionality of Mzingo Partners services.
          </li>
        </ol>

        <h5>How Personal Data is Processed</h5>
        <ol start="4">
          <li>
            Personal Data is or may be used for the following purposes:
            <ul>
              <li>to provide and improve the Service, services, features and content,</li>
              <li>to administer your use of the Service,</li>
              <li>to enable you to enjoy and easily navigate the Site,</li>
              <li>to better understand your needs and interests,</li>
              <li>to fulfill requests you may make,</li>
              <li>to personalize your experience,</li>
              <li>to provide or offer software updates and product announcements, and</li>
              <li>
                to provide you with further information and offers from Mzingo Partners or third
                parties which you may find useful or interesting, including newsletters, marketing
                or promotional.
              </li>
            </ul>
          </li>
          <li>
            Mzingo Partners uses information obtained by technical means (such as the automatic
            recording performed by Mzingo Partners servers or through the use of cookies) for the
            above purposes and in order to monitor and analyze use of the Service and Mzingo
            Partners services,
            <ul>
              <li>for the Service’s technical administration,</li>
              <li>to increase the Service’s functionality and user-friendliness,</li>
              <li>to better tailor it to your needs,</li>
              <li>
                to generate and derive useful data and information concerning the interests,
                characteristics and website use behavior of users,
              </li>
              <li>
                and to verify that visitors to the Service meet the criteria required to process
                their requests.
              </li>
            </ul>
          </li>
        </ol>

        <h5>Information Sharing and Disclosure</h5>
        <ol start="6">
          <li>
            Mzingo Partners won’t display any of your Personal Data in the Service. Please note that
            the information you provide must be accurate and true.
          </li>
          <li>
            Mzingo Partners may employ third party companies and individuals to facilitate the
            Service, to provide services on Mzingo Partners behalf, to perform Service-related
            services (including but not limited to data storage, maintenance services, database
            management, web analytics, payment processing, and improvement of the Service’s
            features) or to assist Mzingo Partners in analyzing how the Service is used. These third
            parties have access to your Personal Information only for purposes of performing these
            tasks on Mzingo Partners behalf.
          </li>
          <li>
            Mzingo Partners cooperates with government and law enforcement officials and private
            parties to enforce and comply with the law. Mzingo Partners will disclose any
            information about you to government or law enforcement officials or private parties as
            Mzingo Partners, in its sole discretion, believe necessary or appropriate to respond to
            claims and legal process (including but not limited to subpoenas), to protect the
            property and rights of Mzingo Partners or a third party, to protect the safety of the
            public or any person, or to prevent or stop any activity Mzingo Partners may consider to
            be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.
          </li>
          <li>
            Mzingo Partners may sell, transfer or otherwise share some or all of its assets,
            including your Personal Information, in connection with a merger, acquisition,
            reorganization or sale of assets or in the event of bankruptcy.
          </li>
          <li>
            We specifically use
            <a href="https://support.google.com/analytics/answer/6004245">Google Analytics</a> to
            analyse how users reach and interact with our site and web application. We collect,
            store and analyse this information for the purpose of providing the best service and
            improvements to all our subscribers and visitors.
          </li>
          <li>
            If you wish to opt out of such data collection by the above third party, Google provides
            a browser based tool that you can install to do so. –
            <a href="https://support.google.com/analytics/answer/181881"
              >Google Analytics opt-out browser add-on</a
            >.
          </li>
        </ol>

        <h5>Security</h5>
        <ol start="13">
          <li>
            Mzingo Partners is very concerned with safeguarding your information. Mzingo Partners
            employs reasonable measures designed to protect your information from unauthorized
            access.
          </li>
        </ol>

        <h5>Data</h5>
        <ol start="14">
          <li>
            Mzingo Partners uses third party vendors and hosting partners to provide the necessary
            hardware, software, networking, storage, and related technology required to run the
            service. Mzingo Partners owns the code, databases, and all rights to the Mzingo Partners
            service, you retain all rights to your files and data. Please see the corresponding
            articles on copyright in the
            <router-link :to="{ name: 'Legal', hash: '#terms-and-conditions' }"
              >Terms and conditions</router-link
            >.
          </li>
        </ol>

        <h5>Your legal rights in connection with your Dat</h5>
        <ol start="15">
          <li>
            By law you have the right to be informed, the right to access to your Personal data, to
            request correction of your data, to request erasure of your data, to restrict processing
            of your data, the right to data portability, the right to object. To exercise these
            rights you can contact Mzingo Partners via email provided in “Contacts”.
          </li>
          <li>
            Your Personal Data will not be kept for longer than is necessary to fulfil purposes
            outlined in Privacy Policy. Any Personally identifiable information Mzingo Partners hold
            will be deleted after a defined period of 26 months. The rest of the Data which is
            anonymous will be used to analyse website trends.
          </li>
        </ol>

        <h5>Changes to This Policy</h5>
        <ol start="17">
          <li>
            This policy may change from time to time. The latest effective date will be highlighted
            at the top of this Privacy Policy.
          </li>
          <li>
            If you do not agree with this Policy or Changes to this Policy do not give your consent
            for Mzingo Partners to process your personal data, do not use our services or provide
            HERE with yours personal data. You have the right to withdraw consent at any time.
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'

export default {
  name: 'Legal',
  components: {
    Subheader,
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/layout';

.card {
  @include card-w-borders();

  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  border: none;
}

h5:not(:first-of-type) {
  margin-top: 2em;
}

a {
  color: $primary;
  text-decoration: underline;
}

b {
  font-weight: 600;
}

ul {
  list-style-type: disc;
  list-style-position: inside;
}

ol {
  list-style-type: decimal;
  list-style-position: inside;
}

ol.roman {
  list-style: none;
  counter-reset: roman-list;

  li {
    counter-increment: roman-list;

    &:before {
      content: '(' counter(roman-list, lower-roman) ') ';
    }
  }
}

.policy ol {
  & > li {
    margin: 1.25rem 0;
  }

  ul > li {
    &:first-of-type {
      margin-top: 0.2em;
    }
  }
}

li {
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  color: #282828;
  font-weight: 200;
  line-height: 1.4rem;

  &:not(:last-of-type) {
    margin-bottom: 0.2em;
  }
}
</style>
